/** IMGLIB-1 · 图片卡片（图片库网格 / 从图片库选 / 产品相册共用）：图 + 类型角标 + 名字 + 副标题；未归类 = 黄色虚线框。 */
import type { ReactNode } from "react";
import { Check } from "lucide-react";
import { KIND_SHORT, type MediaAsset } from "@/services/mediaLibrary";

export function MediaTile({ asset, badge, sub, selected, dim, active, onClick, children, "data-testid": testId }: {
  asset: MediaAsset;
  /** 图左上角小标，默认显示「相册 · 横版 / 宣传图 · 竖版」；未归类显示「未归类」 */
  badge?: string | null;
  sub?: ReactNode;
  selected?: boolean;
  dim?: boolean;
  active?: boolean;
  onClick?: () => void;
  children?: ReactNode;
  "data-testid"?: string;
}) {
  const unclassified = !asset.classified;
  const portrait = asset.kind === "highlight";
  const label = badge === undefined ? (unclassified ? "未归类" : KIND_SHORT[asset.kind]) : badge;
  const border = unclassified ? "border-dashed border-amber-400 bg-amber-50/40" : "border-slate-200 bg-white";
  return (
    <div
      data-testid={testId ?? "media-tile"}
      onClick={dim ? undefined : onClick}
      className={`relative flex flex-col overflow-hidden rounded-lg border transition ${border} ${dim ? "cursor-not-allowed opacity-45" : onClick ? "cursor-pointer hover:border-blue-400" : ""} ${active || selected ? "ring-2 ring-blue-500" : ""}`}
    >
      <div className={`relative w-full bg-slate-200 bg-cover bg-center ${portrait ? "aspect-[3/4]" : "aspect-[3/2]"}`}
        style={{ backgroundImage: `url('${asset.url.replace(/'/g, "%27")}')` }}>
        {label && <span className="absolute left-1.5 top-1.5 rounded bg-slate-900/70 px-1.5 py-0.5 text-[10.5px] text-white">{label}</span>}
        {selected && <span className="absolute right-1.5 top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-blue-600 text-white"><Check size={12} /></span>}
      </div>
      <div className="flex flex-col gap-0.5 px-2 py-1.5 text-[12px]">
        <span className={`truncate font-medium ${unclassified ? "text-amber-700" : "text-slate-800"}`} title={asset.name}>{unclassified ? `⚠ ${asset.name}` : asset.name}</span>
        {sub !== undefined && <span className="text-[11.5px] text-slate-500">{sub}</span>}
        {children}
      </div>
    </div>
  );
}
